import { getStore } from '../store/Store';
import { mutatorAction } from 'satcheljs';

/**
 * Signal that the reading pane header failed to load
 */
export const setDidReadingPaneHeaderLoadingFail = mutatorAction(
    'setDidReadingPaneHeaderLoadingFail',
    (newValue: boolean) => {
        getStore().ReadingPaneHeader.lazyLoadingFailed = newValue;
    }
);
